<div>
  <strong>Url</strong>
  <a target="_blank" rel="noopener noreferrer" [href]="redundancyElement().fileUrl">{{ redundancyElement().fileUrl }}</a>
</div>

<div>
  <strong>Created on</strong>
  <span>{{ redundancyElement().createdAt | ptDate: 'medium' }}</span>
</div>

<div>
  <strong>Expires on</strong>
  <span>{{ redundancyElement().expiresOn | ptDate: 'medium' }}</span>
</div>

<div>
  <strong>Size</strong>
  <span>{{ redundancyElement().size | bytes: 1 }}</span>
</div>
